module.exports = __webpack_public_path__ + "img/chirashi_don.bd418bc0.jpg";